var grecaptcha : any;
namespace AgerLMS.WebSite {

    export interface ContactPageWidgetRequest {
        Recaptcha?: string;
    }

    @Serenity.Decorators.registerClass()
    export class ContactPageWidget extends Serenity.Widget<ContactPageWidgetRequest> {

        button : string = "#ContactPageButton";
        formSelector : string = "#ContactPageForm";

        constructor(element: JQuery, opt: ContactPageWidgetRequest) {
            super(element, opt);

            var form = $(this.formSelector);
            // form.find("input[name='fullname']").val("recep tunaaaa");
            // form.find("input[name='email']").val("receptuna@test.com");
            // form.find("input[name='phone']").val("05051189912");
            // form.find("input[name='subject']").val("Konu Konu Konu Konu");
            // var message = "Mesaj"
            // for (let index = 0; index < 20; index++) {
            //     message += " Mesaj";
            // }
            // form.find("textarea[name='message']").val(message);

            this.bindValidate();

            var self = this;
            $(this.button).click(e => {
                
                e.preventDefault();

                if (!$(this.formSelector).valid()) return;

                let r = <Common.RecaptchaSaveRequest<Logging.ContactMessageRow>>{};
                var entity = <Logging.ContactMessageRow>{};
                entity.Fullname = Q.trim($("input[name='fullname']").val());
                entity.Email = Q.trim($("input[name='email']").val());
                entity.Phone = Q.trim($("input[name='phone']").val());
                entity.Subject = Q.trim($("input[name='subject']").val());
                entity.Message = Q.trim($("textarea[name='message']").val());
                r.Recaptcha = grecaptcha.getResponse();
                r.Entity = entity;

                Logging.ContactMessagePublicService.SaveMessage(r, response => {
                    SweetAlert.swal_success("Mesajınız başarıyla gönderildi.", "Mesajınız başarıyla gönderildi.");
                    this.clearForm();
                }, { onError: (response: Serenity.ServiceResponse) => {
                    SweetAlert.swal_alert(response.Error.Message, response.Error.Message);
                    this.clearForm();
                }});
            });

            $(document).keypress(function(e){
                if (e.which == 13){
                    $(this.button).click();
                }
            });
        }

        private clearForm() 
        {
            $("input[name='fullname']").val("");
            $("input[name='email']").val("");
            $("input[name='phone']").val("");
            $("input[name='subject']").val("");
            $("textarea[name='message']").val("");
            $("#grecaptcha").val("");
            grecaptcha.reset();
        }

        private bindValidate() {
            var self = this;
            
            $.validator.addMethod('trPhone', function(value, element) {
                return value.match(/05[0-9]{8}/);
            },"Geçerli telefon numarası girin.");

            let r = {
                fullname: "required",
                email: {
                    required: true,
                    email: true
                },
                phone: { required : true, trPhone : true, minlength: 11, maxlength: 11 },   
                subject: { required : true, minlength: 10, maxlength: 100 } ,
                message: { required : true, minlength: 50, maxlength: 500 }
            }
            
            let m = {
                fullname: "* Lütfen adınızı belirtin.",
                email: {
                    required: "* Sizinle iletişim kurmak için e-posta adresinize ihtiyacımız var!",
                    email: "* E-posta adresiniz mail@xxx.xxx biçiminde olmalıdır!"
                },
                phone: {
                    required: "* Sizinle iletişim kurmak için cep telefonunuz gereklidir!. 05XXXXXXXXX",
                    trPhone: "* Geçerli bir cep telefonu numarası girin!",
                    minlength : "* Geçerli bir cep telefonu numarası girin!.",
                    maxlength: "* Geçerli bir cep telefonu numarası girin!."
                },
                subject: {
                    required: "* Lütfen konu girin.",
                    minlength : "* Konu en az 10 karakter olmalıdır.",
                    maxlength: "* Konu en fazla 100 karakter olmalıdır."
                },
                message: {
                    required: "* Lütfen mesaj girin.",
                    minlength : "* Mesajınız en az 50 karakter olmalıdır.",
                    maxlength: "* Mesajınız en fazla 500 karakter olmalıdır."
                }
            }

            RT.recaptchaInclude(this.options.Recaptcha, $(self.button), r, m);

            $(this.formSelector).validate({
                errorClass: "is-invalid",
                rules: r,
                messages: m
            });
        }
    }
}